;(function ($) {

    var searchToggleButton = $('#z_search_toggle'),
        searchformHeader = $('#z_searchform_header'),
        searchField = $('#z_searchform_header_field'),
        slickSlider = $('#masthead_slider');

    $(document).ready(function () {

        $('body').on('click', '#z_search_toggle', searchToggle);

        // NOT YET USED
        //$( 'body').on( 'click', '#scroll_to_top', scrollToTop );
        //$( 'body' ).on( 'click', 'ul.page-list span.arrow', toggleSubPages );

        if ($('body').hasClass('page-template-demo-mh-cta-crossfading-images')) {
            initSlickSlider();
        }


        if ($('body').hasClass('page-template-template-masthead-slider-cta-crossfade')) {
            initSlickSliderDots();
        }

        // Share Popups
        $('body').on('click', '.social-share', social_share_popup);

    });

    /**
     * Toggles the search bar in the header and then focuses in the search bar once it appears.
     *
     * @param {object} e
     * @returns {void}
     */
    function searchToggle() {
        //console.log( 'searchToggle' );

        if (searchformHeader.hasClass('open')) {
            searchToggleButton.removeClass('open');
            searchformHeader.removeClass('open');
            searchformHeader.attr('aria-hidden', true);
        } else {
            searchformHeader.addClass('open');
            searchToggleButton.addClass('open');
            searchformHeader.attr('aria-hidden', false);
            searchField.focus();
        }

    }

    /**
     * Init the Slider(s) if any are on page.
     */
    function initSlickSlider() {
        console.log('initSlickSlider');
        if (slickSlider) {

            $('#masthead_slider').slick({
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: false,
                infinite: true,
                pauseOnHover: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                accessibility: true,
                speed: 1200,
                fade: true,
                cssEase: 'linear'
            });
        }

    }

    /**
     * Init the Slider(s) if any are on page.
     */
    function initSlickSliderDots() {

        if (slickSlider) {

            $('#masthead_slider').slick({
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: false,
                infinite: true,
                pauseOnHover: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                accessibility: true,
                speed: 1200,
                fade: true,
                cssEase: 'linear',
                dots: true
            });
        }

    }

    /**
     * Toggles the sub pages in the sidebar
     *
     * @param {object} e
     * @returns {void}
     */
    function toggleSubPages(e) {
        e.preventDefault();
        //console.log( 'submenu toggled' );
        var $this = $(this),
            children = $this.parent('a').siblings('.children');

        if ($this.hasClass('open')) {
            children.slideUp(300, function () {
                $this.removeClass('open');
                children.removeClass('open');
            });
        } else {
            children.slideDown(300, function () {
                $this.addClass('open');
                children.addClass('open');
            });
        }
    }

    /**
     * Animates the page back to the top.
     */
    function scrollToTop() {
        $('html,body').animate({
            scrollTop: 0
        }, 500);
    }

    $(window).load(function () {
        if (Foundation.MediaQuery.atLeast('medium')) {
            initFullResImages();
        }
    });

    /**
     * Looks for any image with data attribute: data-full-res and swaps out the low res version with full res.
     */
    function initFullResImages() {
        // console.log('initFullResImages');
        $('[data-full-res]').each(function (index, item) {
            var $this = $(item),
                fullResURL = $this.attr('data-full-res');


            var image = document.images[index];
            var downloadingImage = new Image();
            downloadingImage.onload = function () {
                $this.css('background-image', 'url(' + fullResURL + ')');
            };
            downloadingImage.src = fullResURL;

        });
    }

    $(window).on('changed.zf.mediaquery', function (event, name) {
        console.log('Breakpoint Watch: ', name);
    });




    /**
     * Gets the popup windows ready depending on share platform, sets up the width/height.
     *
     * @param e
     * @returns {boolean}
     */
    function social_share_popup(e) {
        e.preventDefault();

        let $this = $(this),
            url = $this.attr('href'),
            windowName = 'facebookShareWindow',
            width = 550,
            height = 450;

        if ($this.data('share') === 'twitter') {
            windowName = 'twitterShareWindow';
            height = 260;
        }
        if ($this.data('share') === 'linkedIn') {
            windowName = 'linkedInShareWindow';
            height = 260;
        }
        popup_center(url, windowName, width, height);

        return false;
    }


    /**
     * PopupCenter - opens a popup window in the middle, works with multiple monitors.
     *
     * @param {string} url - full url
     * @param {string} title - window title (use this to manipulate window after its created)
     * @param {int} w - width of window
     * @param {int} h - height of window
     * @returns {void}
     */
    function popup_center(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        let dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

        let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        let left = ((width / 2) - (w / 2)) + dualScreenLeft;
        let top = ((height / 2) - (h / 2)) + dualScreenTop;
        let newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    }


    /**
     * Adds anchor link jump from a different page support to Google Chrome on mobile
     */
    function initChromeMobileSupportdHash() {
        var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        if (window.location.hash && isChrome) {
            setTimeout(function () {
                var hash = window.location.hash;
                window.location.hash = "";
                window.location.hash = hash;
            }, 300);
        }
    }


    /**
     * Adds anchor link jump from a different page support to Safari
     */
    function initSafariSupportHash() {
        var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        if (window.location.hash && isSafari) {
            setTimeout(function () {
                var hash = window.location.hash;
                window.location.hash = "";
                window.location.hash = hash;
            }, 300);
        }
    }

})(jQuery);
